import * as React from 'react'

interface Props {
  img: string[]
  suffixes?: string[]
}

export const ImgPreload = (props: Props) => {
  const {img, suffixes = []} = props
  const urls: string[] = []
  img.forEach(im => {
    const parts = im.split('.')
    const ext = parts.pop()
    const name = parts.join('.')
    urls.push(`/img/${name}.${ext}`)
    suffixes.forEach(suff => urls.push(`/img/${name}${suff}.${ext}`))
  })
  return (
    <div className="_preload">
      {urls.map(src => (
        <img src={src} alt="" key={src} />
      ))}
    </div>
  )
}

export const SVGPreload = (props: Props) => {
  if ((window as any).SVG_OPT) {
    return <div className="_preload" />
  }
  const {img, suffixes = ['-hover', '-active']} = props
  const urls: string[] = []
  img.forEach(im => {
    urls.push(`/img/${im}.svg`)
    suffixes.forEach(suff => urls.push(`/img/${im}${suff}.svg`))
  })

  return (
    <div className="_preload">
      {urls.map(src => (
        <img src={src} alt="" key={src} />
      ))}
    </div>
  )
}
